import axios from '../../node_modules/axios/index';
import axiosInstance from '../Utils/axiosInstance';

const base_url = `${import.meta.env.VITE_REACT_APP_BASE_URL}/doctorsappuser`;
const language = localStorage.getItem('language');

export const fetchUsers = async (token) => {
  if (!token) {
    throw new Error('Authentication token is required');
  }
  const response = await axiosInstance.get(base_url, {
    headers: {
      Authorization: token,
      lang: language,
    },
  });
  return response;
};

export const addUser = async (userData, token) => {
  if (!token) {
    throw new Error('Authentication token is required');
  }
  const response = await axiosInstance.post(base_url, userData, {
    headers: {
      Authorization: token,
      lang: language,
    },
  });
  return response;
};

export const updateUserWithEmail = async (userData, token) => {
  if (!token) {
    throw new Error('Authentication token is required');
  }
  const response = await axiosInstance.put(base_url, userData, {
    headers: {
      Authorization: token,
      lang: language,
    },
  });
  return response;
};

export const deleteUserwithEmail = async (username, token) => {
  if (!token) {
    throw new Error('Authentication token is required');
  }
  const response = await axiosInstance.delete(base_url, {
    headers: {
      Authorization: token,
      lang: language,
    },
    data: { username },
  });
  return response;
};

export const fetchUserHasPermission = async (action, token) => {
  if (!token) {
    throw new Error('Authentication token is required');
  }
  try {
    const response = await axiosInstance.get(`${base_url}/checkpermission`, {
      params: { action },
      headers: {
        Authorization: token,
        lang: language,
      },
    });

    const hasPermission = response.data.hasPermission;
    return hasPermission;
  } catch (error) {
    console.error('Error fetching user:', error.response?.data || error.message);
    throw error;
  }
};

export const updateUserInfo = async (data) => {
  try {
    const resposne = await axiosInstance.put(`/doctorsappuser/update`, data, {
      headers: {
        Authorization: localStorage.getItem('token'),
        lang: language,
      },
    });
    return resposne;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getUsersCount = async () => {
  try {
    const response = await axiosInstance.get(`/doctorsappuser/all-users-count`, {
      headers: {
        Authorization: localStorage.getItem('token'),
        lang: language,
      },
    });
    return response.data.data;
  } catch (error) {
    throw new Error('Failed to fetch users count');
  }
};

export const fetchSpecialities = async () => {
  const response = await axiosInstance.get(`/doctorsappspecialities`, {
    headers: {
      Authorization: localStorage.getItem('token'),
      lang: language,
    },
  });
  return response;
};

// New Specialty Management APIs
export const addSpecialty = async (specialtyData) => {
  const response = await axiosInstance.post(`/doctorsappspecialities`, specialtyData, {
    headers: {
      Authorization: localStorage.getItem('token'),
      lang: language,
    },
  });
  return response;
};

export const updateSpecialty = async (id, specialtyData) => {
  const response = await axiosInstance.put(`/doctorsappspecialities/${id}`, specialtyData, {
    headers: {
      Authorization: localStorage.getItem('token'),
      lang: language,
    },
  });
  return response;
};

export const deleteSpecialty = async (id) => {
  const response = await axiosInstance.delete(`/doctorsappspecialities/${id}`, {
    headers: {
      Authorization: localStorage.getItem('token'),
      lang: language,
    },
  });
  return response;
};

export const activateSpeciality = async (id) => {
  const response = await axiosInstance.put(`/doctorsappspecialities/activate/${id}`, {
    headers: {
      Authorization: localStorage.getItem('token'),
      lang: language,
    },
  });
  return response;
};
export const deactivateSpeciality = async (id) => {
  const response = await axiosInstance.put(`/doctorsappspecialities/deactivate/${id}`, {
    headers: {
      Authorization: localStorage.getItem('token'),
      lang: language,
    },
  });
  return response;
};

export const getUserByTempPass = async (tempPass) => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_REACT_APP_BASE_URL}/doctorsappuser/get-user-by-temp-pass`,
      {
        params: { temp_pass: tempPass },
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching user by temporary password:', error);
    throw error;
  }
};

export const updateUserPass = async (email) => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_REACT_APP_BASE_URL}/doctorsappuser/update-user-pass`,
      {},
      {
        params: { email },
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user.', error);
    throw error;
  }
};
